import { Radio as RadioMantine } from '@mantine/core'
import React, { useCallback, useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useDispatch } from 'react-redux'

import { api_gateway } from '../../../conexoes/api'
import { filtrosArrayBarra } from '../../../redux/actions/index'
import { useGlobal } from '../../../stores/useGlobal'
import Grid from '../../Mantine/Grid'
import Modal from '../../Mantine/Modal'
import Radio from '../../Mantine/Radio'
import Select from '../../Mantine/Select'

import * as S from './styles'

// eslint-disable-next-line no-magic-numbers
const WIDTH_COLUMNS = [3, 3, 3, 3]

const DEFAULT_FILTERS_VALUES = {
  motivo_inativacao: '',
  status: '',
  usuario_vendedor: '',
  conta_sms: ''
}

const OPTIONS_STATUS = [
  {
    value: 'ativo',
    label: 'Ativo'
  },
  {
    value: 'inativo',
    label: 'Inativo'
  }
]

const OPTIONS_USUARIO_VENDEDOR = [
  {
    label: 'Sim',
    value: 'sim'
  },
  {
    label: 'Não',
    value: 'nao'
  }
]

const OPTIONS_CONTA_SMS = [
  {
    label: 'Ativa',
    value: 'sim'
  },
  {
    label: 'Inativa',
    value: 'nao'
  }
]

export default function FiltrosPainelAdmUsuarios({ opened, close }) {
  const { filtros, setFiltros, setRevelarBarraFiltro, setIsLoadingGlobal } =
    useGlobal()

  const despacho = useDispatch()

  const [localFilters, setLocalFilters] = useState({
    ...DEFAULT_FILTERS_VALUES
  })

  let arrayFiltrosBarra = []

  const { data: motivosInativacao } = useQuery(
    ['consultar_pav_usuario_bloqueio_status'],
    async () => {
      try {
        setIsLoadingGlobal(true)

        const data = await api_gateway.post('/m1/consultar/select', {
          dados: {},
          condicao: {
            paramRota: 'pav_usuario_bloqueio_status'
          }
        })

        return data.data.dados
      } catch (err) {
        console.error(err)
      } finally {
        setIsLoadingGlobal(false)
      }
    },
    {
      staleTime: 600000, //* 10 minutos
      cacheTime: 600000, //* Mantém no cache por 10 minutos após ficar inativo
      keepPreviousData: true,
      refetchOnWindowFocus: false
    }
  )
  const OPTIONS_SELECT = (motivosInativacao || []).map((item) => ({
    value: item.codigo,
    label: item.descricao1
  }))

  useEffect(() => {
    if (filtros.vazio) return

    const auxFilter = {
      ...DEFAULT_FILTERS_VALUES
    }

    if (filtros?.fl_ativo) {
      const status = filtros?.fl_ativo === '1' ? 'ativo' : 'inativo'
      auxFilter.status = status
    }

    if (filtros?.cd_pav_usuario_bloqueio_status) {
      auxFilter.motivo_inativacao = filtros?.cd_pav_usuario_bloqueio_status
    }

    if (filtros?.fl_vendedor) {
      const vendedor = filtros?.fl_vendedor === '1' ? 'sim' : 'nao'
      auxFilter.usuario_vendedor = vendedor
    }

    if (filtros?.userHasSMS) {
      const temContaSms = filtros?.userHasSMS === '1' ? 'sim' : 'nao'
      auxFilter.conta_sms = temContaSms
    }

    setLocalFilters(auxFilter)
  }, [filtros])

  const formattedFilter = () => {
    if (localFilters.motivo_inativacao) {
      const motivo = OPTIONS_SELECT.find(
        (item) => item.value === localFilters.motivo_inativacao
      ).label

      arrayFiltrosBarra.push(`Motivo da inativação: ${motivo}`)
    }

    if (localFilters.status) {
      const status = OPTIONS_STATUS.find(
        (item) => item.value === localFilters.status
      ).label

      arrayFiltrosBarra.push(`Status Usuário: ${status}`)
    }

    if (localFilters.usuario_vendedor) {
      const vendedor = OPTIONS_USUARIO_VENDEDOR.find(
        (item) => item.value === localFilters.usuario_vendedor
      ).label

      arrayFiltrosBarra.push(`Usuário vendedor: ${vendedor}`)
    }

    if (localFilters.conta_sms) {
      const vendedor = OPTIONS_CONTA_SMS.find(
        (item) => item.value === localFilters.conta_sms
      ).label

      arrayFiltrosBarra.push(`Usuário com conta SMS: ${vendedor}`)
    }

    despacho(filtrosArrayBarra(arrayFiltrosBarra))
  }

  const handleFilter = () => {
    const filteredData = {
      cd_pav_usuario_bloqueio_status: localFilters.motivo_inativacao,
      ...(localFilters.status
        ? { fl_ativo: localFilters.status === 'ativo' ? '1' : '0' }
        : {}),
      ...(localFilters.usuario_vendedor
        ? { fl_vendedor: localFilters.usuario_vendedor === 'sim' ? '1' : '0' }
        : {}),
      ...(localFilters.conta_sms
        ? { userHasSMS: localFilters.conta_sms === 'sim' ? '1' : '0' }
        : {})
    }

    let finalFiltros = Object.fromEntries(
      Object.entries(filteredData).filter(([, value]) => value)
    )

    setFiltros(finalFiltros)
    setRevelarBarraFiltro(true)
    formattedFilter()
    close()
  }

  const handleCleanFilters = () => {
    setLocalFilters(DEFAULT_FILTERS_VALUES)
    setFiltros({ vazio: 'vazio' })
    despacho(filtrosArrayBarra([]))
    setRevelarBarraFiltro(false)
  }

  const handleChange = useCallback(
    (campo, value) => {
      setLocalFilters((prev) => ({
        ...prev,
        [campo]: value
      }))
    },
    [setLocalFilters]
  )

  return (
    <Modal
      width="1030px"
      type="filtro"
      titulo="Filtros"
      opened={opened}
      close={close}
      onConfirm={handleFilter}
      handleCleanFilters={handleCleanFilters}
    >
      <S.Container>
        <S.Card>
          <Grid grow colSize={WIDTH_COLUMNS}>
            <RadioMantine.Group
              name="STATUS"
              value={localFilters?.status}
              onChange={(value) => handleChange('status', value)}
            >
              <S.ItemFiltro>
                <S.Label>Status</S.Label>
                <S.RadioWrapper>
                  {OPTIONS_STATUS?.map((opcao) => (
                    <Radio
                      key={opcao.value}
                      value={opcao.value}
                      label={opcao.label}
                    />
                  ))}
                </S.RadioWrapper>
              </S.ItemFiltro>
            </RadioMantine.Group>
            <RadioMantine.Group
              name="USUARIO_VENDEDOR"
              value={localFilters?.usuario_vendedor}
              onChange={(value) => handleChange('usuario_vendedor', value)}
            >
              <S.ItemFiltro>
                <S.Label>Usuário vendedor</S.Label>
                <S.RadioWrapper>
                  {OPTIONS_USUARIO_VENDEDOR?.map((opcao) => (
                    <Radio
                      key={opcao.value}
                      value={opcao.value}
                      label={opcao.label}
                    />
                  ))}
                </S.RadioWrapper>
              </S.ItemFiltro>
            </RadioMantine.Group>
            <RadioMantine.Group
              name="CONTA_SMS"
              value={localFilters?.conta_sms}
              onChange={(value) => handleChange('conta_sms', value)}
            >
              <S.ItemFiltro>
                <S.Label>Conta SMS</S.Label>
                <S.RadioWrapper>
                  {OPTIONS_CONTA_SMS?.map((opcao) => (
                    <Radio
                      key={opcao.value}
                      value={opcao.value}
                      label={opcao.label}
                    />
                  ))}
                </S.RadioWrapper>
              </S.ItemFiltro>
            </RadioMantine.Group>

            <S.ItemFiltro>
              <S.Label>Motivo da inativação</S.Label>
              <S.RadioWrapper>
                <Select
                  placeholder="Selecione"
                  value={localFilters.motivo_inativacao}
                  options={OPTIONS_SELECT}
                  onChange={(value) => handleChange('motivo_inativacao', value)}
                />
              </S.RadioWrapper>
            </S.ItemFiltro>
          </Grid>
        </S.Card>
      </S.Container>
    </Modal>
  )
}
